import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import { GameIntroScene } from './scenes/GameIntro';
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';

interface PhaserShipPaintingGameProps {
    onComplete: () => void;
}

interface PhaserShipPaintingGameState {
}

const gameConfig: GameConfig = {
    title: "Space Ship Painting Game",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserShipPaintingGame extends React.Component<PhaserShipPaintingGameProps, PhaserShipPaintingGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserShipPaintingGameProps) {
        super(props);
        bindAllOfThis(this, PhaserShipPaintingGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserShipPaintingGame;



// WEBPACK FOOTER //
// ./src/games/ShipPainting/Main.tsx